import { render, staticRenderFns } from "./question-card.vue?vue&type=template&id=770acbda&scoped=true"
import script from "./question-card.vue?vue&type=script&lang=js"
export * from "./question-card.vue?vue&type=script&lang=js"
import style0 from "./question-card.vue?vue&type=style&index=0&id=770acbda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770acbda",
  null
  
)

export default component.exports